module.exports = __webpack_public_path__ + "img/credit-one-club-gal-4.1c9ae1d8.jpg";